import Market from '../../../model/Market'
import { loadMarketList as apiLoadMarketList } from '../../../rest-api/Market-api'
import { Dispatch } from 'redux'
import { actionCreatorFactory, AnyAction } from 'typescript-fsa'
import wrapAsyncWorker from '../../../common/wrapAsyncWorker'
import { loadSiteConfigList } from '../../SiteConfigList/actions/LoadSiteConfigList'

const actionCreator = actionCreatorFactory()

export const LoadMarketList = actionCreator.async<null, Market[], string>('LoadMarketList')

const loadMarketListWorker = wrapAsyncWorker(LoadMarketList, apiLoadMarketList)

// thunk action creator
export const loadMarketList = () => {
  return (dispatch: Dispatch<AnyAction>) => loadMarketListWorker(dispatch, null).then((markets) => {
    markets.forEach(market => {
      if (market.key !== 'global') {
        dispatch(loadSiteConfigList(market.key) as any)
      }
    });
  })
}
